'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Spinner } from '@common/components';
import { cn } from '@core/utils';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useInView } from 'react-intersection-observer';
import { AuthInfiniteQueryOptions, UnauthInfiniteQueryOptions } from '@/api';
import { InquiryCard } from '@/app/donation/_components/InquiryCard';
import { INQUIRY_TYPE } from '@/app/donation/constants';
import type { InquiryType } from '@/app/donation/types';
import { DONATION_ROUTES, STORAGE_KEY } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useLoginGuard } from '@/hooks/useLoginGuard';
import { useAuthStore } from '@/stores/AuthStore';
import { filledInfiniteQueryOptions } from '@/utils/filledInfiniteQueryOptions';
import { TABS } from '../../../constants';
import { ResponsiveDivider } from '../../GiftDetailTemplate/ResponsiveDivider';
const INITIAL_PAGE = 1;
const INITIAL_SIZE = 20;
interface GiftTabContentInquiryProps {
  productNumber: string;
}
export const GiftTabContentInquiry = t0 => {
  const $ = _c(28);
  const {
    productNumber
  } = t0;
  const isLogin = useAuthStore(_temp);
  const router = useCustomRouter();
  const loginGuard = useLoginGuard();
  let t1;
  if ($[0] !== isLogin || $[1] !== productNumber) {
    t1 = filledInfiniteQueryOptions(isLogin ? AuthInfiniteQueryOptions["get:/wello/v2/auth/home-inquiry"]({
      query: {
        page: INITIAL_PAGE,
        size: INITIAL_SIZE,
        productNumber
      }
    }) : UnauthInfiniteQueryOptions["get:/wello/v2/allows/home-inquiry"]({
      query: {
        page: INITIAL_PAGE,
        size: INITIAL_SIZE,
        productNumber
      }
    }));
    $[0] = isLogin;
    $[1] = productNumber;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isLogin !== undefined;
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching
  } = useInfiniteQuery(t3);
  let t4;
  if ($[6] !== fetchNextPage || $[7] !== isFetching) {
    t4 = {
      onChange: inView => {
        if (!isFetching && inView) {
          fetchNextPage();
        }
      }
    };
    $[6] = fetchNextPage;
    $[7] = isFetching;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    ref
  } = useInView(t4);
  const totalCount = data?.pages[0]?.context?.totalCount ?? 0;
  const isDisplayList = totalCount > 0;
  const t5 = !isDisplayList;
  let t6;
  if ($[9] !== t5) {
    t6 = cn("flex flex-col pt-32", "mobile-tablet:pt-28", {
      "pb-60 mobile-tablet:pb-0": t5
    });
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className={cn("mb-4 font-700 text-Gray-900 typo-body1", "mobile-tablet:typo-body3")}>답례품에 대해 궁금한 것이 있으신가요?</p>;
    t8 = <p className={cn("mb-32 font-400 text-Gray-600 typo-body2", "mobile-tablet:mb-20 mobile-tablet:typo-body4")}>답례품 관련 문의는 판매자가 상세히 답변드려요.</p>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cn("w-[375px]", "mobile-tablet:w-fit");
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== loginGuard || $[15] !== productNumber || $[16] !== router) {
    t10 = <div className="flex w-full flex-col items-center pb-28">{t7}{t8}<Button data-no-donation-accent={true} className={t9} roundness="capsule" dimensions="H40" onClick={() => {
        if (!loginGuard()) {
          return;
        }
        sessionStorage.setItem(STORAGE_KEY.IS_DONATION_INQUIRY_BY_GIFT_PRODUCT, "true");
        router.push(DONATION_ROUTES.MY_INQUIRY_POSTING.withSearchParams({
          dynamicPath: {
            type: INQUIRY_TYPE.GIFT_PRODUCT
          },
          searchParams: {
            productNumber,
            redirect: window.location.pathname + window.location.search
          }
        }));
      }}>답례품 문의하기</Button></div>;
    $[14] = loginGuard;
    $[15] = productNumber;
    $[16] = router;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== data?.pages || $[19] !== hasNextPage || $[20] !== isDisplayList || $[21] !== ref || $[22] !== totalCount) {
    t11 = isDisplayList ? <section className="flex flex-col"><ResponsiveDivider /><section className="flex flex-col pt-32 mobile-tablet:pt-16"><h2 className="px-20 pb-16 font-700 text-Gray-900 typo-body2 mobile-tablet:text-Gray-black">답례품 문의 ({totalCount.toLocaleString()})</h2><ul className="flex flex-col">{data?.pages.flatMap(_temp2).map(_temp3)}</ul>{hasNextPage ? <div className="my-30 w-full flex-center" ref={ref}><Spinner /></div> : null}</section></section> : null;
    $[18] = data?.pages;
    $[19] = hasNextPage;
    $[20] = isDisplayList;
    $[21] = ref;
    $[22] = totalCount;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t6) {
    t12 = <section className={t6} id={TABS.INQUIRY}>{t10}{t11}</section>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t6;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(page) {
  return page.context?.contents ?? [];
}
function _temp3(t0) {
  const {
    homeInquiryId: home_inquiry_id,
    inquiryTypeValue: inquiry_type_value,
    contents,
    createAt: create_at,
    productName: product_name,
    institutionName: institution_name,
    institutionLogoUrl: institution_logo_url,
    answer,
    writerYN: writer_yn,
    optionItems: option_items,
    privateYN: private_yn,
    title,
    fileUrlList: file_url_list,
    mainImageUrl: main_image_url,
    inquiryTypeCd: inquiry_type_cd
  } = t0;
  return <li key={home_inquiry_id}><InquiryCard inquiryType={inquiry_type_value} contents={contents} createAt={create_at} productName={product_name} institutionName={institution_name} institutionLogoUrl={institution_logo_url} answer={answer} writerYN={writer_yn} optionItems={option_items} privateYN={private_yn} title={title} fileUrlList={file_url_list} mainImageUrl={main_image_url} inquiryId={home_inquiry_id} inquiryTypeCd={inquiry_type_cd as InquiryType} isProductVisible={false} className="border-b border-Gray-200" /></li>;
}